import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './SessionModal.module.scss';
import ReactModal from 'react-modal';
import { logout } from '../../../store/actions/auth.action';
import { timerUpdated } from '../../../store/actions/session.action';
import { sessionSelector } from '../../../store/reducers/session.reducer';
import moment from 'moment';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '30vw'
  },
};
if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#modal');

let sessionTimer,
  alertTimer,
  countDownTimer,
  sessionDelay = 15 * 60 * 1000;

const SessionModal = () => {
  const dispatch = useDispatch();
  const { updateTimerFlag, removeTimer } = useSelector(sessionSelector);

  const [isOpen, setModalOpen] = useState(false);
  const [secondsLeft, setSecodsLeft] = useState(60);
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    handleRefresh();
    if (updateTimerFlag) dispatch(timerUpdated());
    return () => {
      if (sessionTimer) clearTimeout(sessionTimer);
      if (alertTimer) clearTimeout(alertTimer);
      if (countDownTimer) clearInterval(countDownTimer);
    };
  }, [updateTimerFlag]);
  useEffect(() => {
    if (removeTimer) {
      setModalOpen(true);
      setSessionExpired(true)
    }
  }, [removeTimer])

  const handleLogout = () => {
    const time = localStorage.getItem('session-time')
    const expired = moment().diff(moment(time), 'minutes') >= sessionDelay/(60*1000)
    if (sessionTimer) clearTimeout(sessionTimer);
    if (alertTimer) clearTimeout(alertTimer);
    if (countDownTimer) clearInterval(countDownTimer);
    if (!expired) return
    if (process.env.NODE_ENV !== 'development') dispatch(logout(true));
  };
  const handleRefresh = () => {
    if (sessionTimer) clearTimeout(sessionTimer);
    if (alertTimer) clearTimeout(alertTimer);
    if (countDownTimer) clearInterval(countDownTimer);
    sessionTimer = setTimeout(handleLogout, sessionDelay);
  };
  const handleLogin = () => {
    let a = document.createElement('a');
    a.href = process.env.REACT_APP_LOGIN_URL || 'https://staging.chartrequest.com/';
    setTimeout(() => {
      a.click();
      a.remove();
    }, 0);
  };

  if (sessionExpired) {
    return (
      <ReactModal isOpen={isOpen} style={customStyles}>
        <div style={{ fontSize: '14px' }} className="text-muted">Your session has expired!</div>
        <hr />
        <div style={{ fontSize: '12px' }}>
          <div className="mb-4">Your session has expired. Please login again.</div>
          <div className={styles['buttons']}>
            <button id="delete" className='btn btn-primary' onClick={handleLogin}>
              Click to login
            </button>
          </div>
        </div>
      </ReactModal>
    );
  }
  return (
    <ReactModal isOpen={isOpen} style={customStyles}>
      <div className="text-muted" style={{ fontSize: '14px' }}>
        Your session is about to expire!
      </div>
      <hr />
      <div style={{ fontSize: '12px' }}>
        <div className="mb-2">
          You will be logged out in <span style={{ fontSize: '24px' }}>{secondsLeft}</span> seconds.
        </div>
        <div className="mb-4">Do you want to stay signed in?</div>
        <div className={styles['buttons']}>
          <button id="delete" className='btn btn-primary' onClick={handleRefresh}>
            Yes, Keep me signed in
          </button>
          <button className='ml-3 btn btn-sm btn-danger' type='danger' onClick={handleLogout}>
            No, Sign me out
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default SessionModal;
